<div class="p-6 bg-slate-50 dark:bg-slate-900 min-h-screen font-['Lato',sans-serif]">
  <!-- Operational decisions -->
  <header class="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between mb-4">
    <h2 class="m-0"><span
        class="font-['Lato',sans-serif] text-[20px] font-bold tracking-[-0.4px] text-slate-900 dark:text-white normal-case">Operational
        Decisions</span></h2>
    <div class="flex items-center gap-3 flex-wrap justify-end">
      <app-date-picker [size]="'md'" (valueChange)="rangeValues($event)" (dateRangeChange)="onDateRangeChange($event)"
        [showComparison]="true" [showGroupBy]="true" [allowedGroupByUnits]="allowedGroupByUnits">
      </app-date-picker>

    </div>
  </header>

  <!-- Operational decisions -->
  <section class="mb-8">
    <div class="grid grid-cols-1 md:grid-cols-3 gap-6 items-stretch relative">
      @if(isLoading()){ <app-individual-toaster></app-individual-toaster> }
      <!-- Deliverability Leak -->
      <div
        class="bg-white dark:bg-slate-800 pt-[18px] pr-[18px] pb-[16px] pl-[22px] rounded-xl border border-slate-100 shadow-sm relative overflow-hidden flex flex-col h-full">
        <div class="absolute top-0 left-0 w-1.5 h-full bg-red-600"></div>
        <div class="flex items-center gap-2 mb-[11px]">
          <div class="w-2 h-2 rounded-full bg-red-600"></div>
          <span class="text-[10.5px] font-[700] tracking-[0.7px] text-red-600 uppercase">Deliverability Leak</span>
        </div>
        <p class="text-[14.5px] font-[400] leading-[1.5] text-slate-700 dark:text-slate-200 mb-[16px]">
          <strong class="font-[700] text-black dark:text-white">{{ remindersByChannelData().channel }}
            reminders</strong> are failing at <strong class="font-[700] text-black dark:text-white">{{
            remindersByChannelData().percentage }}%</strong> — {{
          remindersByChannelData().failed | number }} of {{ remindersByChannelData().total | number }} never
          delivered,
          vs just {{
          remindersByChannelData().emailFailed }}% for email.
        </p>
        <div class="border-t border-dashed border-slate-200 dark:border-slate-700 mb-[12px]"></div>
        <div class="text-[9.5px] font-[700] tracking-[0.7px] text-slate-500 uppercase mb-[5px]">Action</div>
        <p class="text-[12.5px] leading-[1.5] text-slate-600 dark:text-slate-400 mb-[14px]">Move to a verified SMS
          sender ID + automatic email fallback on every failed text.</p>

      </div>

      <!-- Upfront Re-Marketing -->
      <div
        class="bg-white dark:bg-slate-800 pt-[18px] pr-[18px] pb-[16px] pl-[22px] rounded-xl border border-slate-100 shadow-sm relative overflow-hidden flex flex-col h-full">
        <div class="absolute top-0 left-0 w-1.5 h-full bg-[#f97316]"></div>
        <div class="flex items-center gap-2 mb-[11px]">
          <div class="w-2 h-2 rounded-full bg-[#f97316]"></div>
          <span class="text-[10.5px] font-[700] tracking-[0.7px] text-[#ea580c] uppercase">Upfront Re-Marketing</span>
        </div>
        <p class="text-[14.5px] font-[400] leading-[1.5] text-slate-700 dark:text-slate-200 mb-[16px]">
          <strong class="font-[700] text-black dark:text-white">{{ upfrontDisbursedData().declined | number }}
            eligible
            businesses declined</strong> an upfront advance and <strong class="font-[700] text-black dark:text-white">{{
            upfrontDisbursedData().deferred | number }}</strong> are deferred — only {{
          upfrontDisbursedData().acceptanceRate
          }}% of eligible accepted.
        </p>
        <div class="border-t border-dashed border-slate-200 dark:border-slate-700 mb-[12px]"></div>
        <div class="text-[9.5px] font-[700] tracking-[0.7px] text-slate-500 uppercase mb-[5px]">Action</div>
        <p class="text-[12.5px] leading-[1.5] text-slate-600 dark:text-slate-400 mb-[14px]">Re-market upfront to the
          declined cohort with a clearer cash-now value message; auto-trigger when deferral windows expire.</p>

      </div>

      <!-- Recovery Engine -->
      <div
        class="bg-white dark:bg-slate-800 pt-[18px] pr-[18px] pb-[16px] pl-[22px] rounded-xl border border-slate-100 shadow-sm relative overflow-hidden flex flex-col h-full">
        <div class="absolute top-0 left-0 w-1.5 h-full bg-emerald-600"></div>
        <div class="flex items-center gap-2 mb-[11px]">
          <div class="w-2 h-2 rounded-full bg-emerald-600"></div>
          <span class="text-[10.5px] font-[700] tracking-[0.7px] text-emerald-600 uppercase">Recovery Engine</span>
        </div>
        <p class="text-[14.5px] font-[400] leading-[1.5] text-slate-700 dark:text-slate-200 mb-[16px]">
          The recovery playbook is proven at a <strong class="font-[700] text-black dark:text-white">{{
            debtRecoveryData().paidOffRate }}% paid-off rate</strong> — yet <strong
            class="font-[700] text-black dark:text-white">{{ debtRecoveryData().recoveryContractsSummary }}</strong>.
          <!-- are not yet enrolled in it. -->
        </p>
        <div class="border-t border-dashed border-slate-200 dark:border-slate-700 mb-[12px]"></div>
        <div class="text-[9.5px] font-[700] tracking-[0.7px] text-slate-500 uppercase mb-[5px]">Action</div>
        <p class="text-[12.5px] leading-[1.5] text-slate-600 dark:text-slate-400 mb-[14px]">Scale the proven recovery
          playbook onto the <strong class="font-[600]">{{ debtRecoveryData().contractsActive }}</strong> currently
          active contracts
          before late-fees compound.</p>
      </div>
    </div>
  </section>

  <!-- Portfolio & recovery at a glance -->
  <section class="mb-8 mt-10">

    <h3
      class="font-['Lato',sans-serif] text-[20px] font-bold tracking-[-0.4px] text-slate-900 dark:text-white capitalize normal-case mb-5 mt-[-10px]">
      Portfolio & Recovery at a Glance
    </h3>

    <div class="grid grid-cols-1 md:grid-cols-3 gap-6 relative">
      @if(isLoading()){ <app-individual-toaster></app-individual-toaster> }
      <!-- Overdue Contracts -->
      <div
        class="bg-white dark:bg-slate-800 p-4 rounded-xl shadow-sm border border-red-200 dark:border-slate-700 border-l-[3px] border-l-red-600 relative overflow-hidden flex flex-col justify-between">
        <div class="flex justify-between items-start mb-2">
          <h3 class="text-[11px] font-bold text-slate-500 uppercase tracking-wider">Overdue Contracts</h3>
          <span
            class="text-[9px] font-bold bg-[#FFEDD5] text-[#C2410C] px-2 py-1 rounded-full uppercase tracking-wider">RISK</span>
        </div>
        <div
          class="font-['Lato',sans-serif] text-[26px] font-normal leading-[1] tracking-[-1px] text-slate-900 dark:text-white mb-2">
          {{ contractStatusData().overdueContracts | number }}
        </div>
        <div class="text-[11.5px] leading-[1.45] text-slate-500 mb-4">{{ contractStatusData().financedBookPct |
          number:'1.0-1' }}% of the
          financed book</div>
        <div class="text-[11px] font-[500] flex items-center gap-1.5 text-slate-600 dark:text-slate-300">
          <div class="w-1.5 h-1.5 rounded-full bg-red-600"></div>
          Target recovery playbook here next
        </div>
      </div>

      <!-- Total Debt Recovered -->
      <div
        class="bg-white dark:bg-slate-800 p-4 rounded-xl shadow-sm border border-purple-200 dark:border-slate-700 border-l-[3px] border-l-purple-600 relative overflow-hidden flex flex-col justify-between">
        <div class="flex justify-between items-start mb-2">
          <h3 class="text-[11px] font-bold text-slate-500 uppercase tracking-wider">Total Debt Recovered</h3>
          <span
            class="text-[9px] font-bold bg-purple-100 text-purple-700 px-2 py-1 rounded-full uppercase tracking-wider">ENGINE</span>
        </div>
        <div
          class="font-['Lato',sans-serif] text-[26px] font-normal leading-[1] tracking-[-1px] text-slate-900 dark:text-white mb-2">
          ${{ debtRecoveryData().totalDebtRecovered | number:'1.0-2' }}
        </div>
        <div class="text-[11.5px] leading-[1.45] text-slate-500 mb-4">{{ debtRecoveryData().paidOffSummary }}</div>
        <div class="mt-auto">
          <div class="h-1.5 rounded-full bg-indigo-50 dark:bg-slate-700 overflow-hidden relative mb-1.5 w-full">
            <div class="h-full rounded-full bg-indigo-500 relative" [style.width.%]="debtRecoveryData().paidOffRate">
            </div>
          </div>
          <div class="flex justify-between text-[10px] font-[500] text-slate-500">
            <span>{{ debtRecoveryData().paidOffRate | number:'1.0-1' }}% paid off</span>
            <span>{{ debtRecoveryData().contractsActive }} recovery contracts active</span>
          </div>
        </div>
      </div>

      <!-- Late-Fee Exposure -->
      <div
        class="bg-white dark:bg-slate-800 p-4 rounded-xl shadow-sm border border-slate-100 dark:border-slate-700 relative overflow-hidden flex flex-col justify-between">

        <div class="flex justify-between items-start mb-2">
          <h3 class="text-[11px] font-bold text-slate-500 uppercase tracking-wider">Late-Fee Exposure</h3>
          <span
            class="text-[9px] font-bold bg-[#FFEDD5] text-[#C2410C] px-2 py-1 rounded-full uppercase tracking-wider">FRICTION</span>
        </div>
        <div
          class="font-['Lato',sans-serif] text-[26px] font-normal leading-[1] tracking-[-1px] text-slate-900 dark:text-white mb-2">
          ${{ lateFeesData().totalLateFees | number:'1.0-0' }}
        </div>
        <div class="text-[11.5px] leading-[1.45] text-slate-500 mb-4">Across {{ lateFeesData().instances | number }}
          late-fee instances - a fixable friction signal</div>
        <div class="text-[11px] font-[500] flex items-center gap-1.5 text-slate-600 dark:text-slate-300 mt-auto">
          <div class="w-1.5 h-1.5 rounded-full bg-orange-400"></div>
          Pair with deliverability fix
        </div>
      </div>
    </div>
  </section>

  <!-- Cash Up Front Section -->
  <section class="mb-10">

    <h3
      class="font-['Lato',sans-serif] text-[20px] font-bold tracking-[-0.4px] text-slate-900 dark:text-white normal-case mb-5">
      Upfront Advances & Eligibility
    </h3>

    <div class="grid grid-cols-1 md:grid-cols-12 gap-6 items-stretch relative">
      @if(isLoading()){ <app-individual-toaster></app-individual-toaster> }
      <!-- Left side cards -->
      <div class="md:col-span-6 flex flex-col gap-4">
        <!-- Eligibility Rate -->
        <div
          class="bg-white dark:bg-slate-800 p-[18px] rounded-xl border border-slate-100 shadow-sm relative overflow-hidden flex flex-col justify-between group">
          <div class="flex justify-between items-start mb-2">
            <h4 class="text-[10.5px] font-[700] tracking-[0.7px] text-slate-500 uppercase">Eligibility Rate</h4>
            <span
              class="text-[9.5px] font-[700] bg-purple-50 text-purple-600 px-2 py-1 rounded-md uppercase tracking-wider">Gate</span>
          </div>
          <div
            class="font-['Lato',sans-serif] text-[26px] font-normal leading-[1] tracking-[-1px] text-slate-900 dark:text-white mb-2">
            {{ upfrontEligibilityData().rate | number:'1.0-1' }}%
          </div>
          <div class="text-[11.5px] leading-[1.45] text-slate-500 mb-3">
            {{ upfrontEligibilityData().eligible | number }} of {{ upfrontEligibilityData().total | number }}
            businesses are eligible &middot; {{ upfrontEligibilityData().notEligible | number }} not eligible
          </div>

        </div>

        <!-- Upfront Acceptance -->
        <div
          class="bg-white dark:bg-slate-800 p-[18px] rounded-xl border border-purple-200 dark:border-purple-800 shadow-sm relative overflow-hidden flex flex-col justify-between">
          <div class="absolute top-0 left-0 w-[3px] h-full bg-purple-600"></div>
          <div class="flex justify-between items-start mb-2 pl-1.5">
            <h4 class="text-[10.5px] font-[700] tracking-[0.7px] text-slate-500 uppercase">Upfront Acceptance</h4>
            <span
              class="text-[9.5px] font-[700] bg-purple-50 text-purple-600 px-2 py-1 rounded-md uppercase tracking-wider">Key
              Lever</span>
          </div>
          <div
            class="font-['Lato',sans-serif] text-[26px] font-normal leading-[1] tracking-[-1px] text-slate-900 dark:text-white mb-2 pl-1.5">
            {{ upfrontDisbursedData().acceptanceRate | number:'1.0-1' }}%
          </div>
          <div class="text-[11.5px] leading-[1.45] text-slate-500 mb-4 pl-1.5">
            {{ upfrontDisbursedData().totalAccepted | number }} of {{ upfrontDisbursedData().totalEligible | number }}
            eligible accepted &middot; {{ upfrontDisbursedData().declined | number }} declined &middot; {{
            upfrontDisbursedData().deferred | number }} deferred
          </div>

          <div class="mt-auto pl-1.5 pr-1">
            <div class="h-1.5 rounded-full bg-indigo-50 dark:bg-slate-700 overflow-hidden relative mb-1.5 w-full">
              <div class="h-full rounded-full bg-[#4f46e5] relative"
                [style.width.%]="upfrontDisbursedData().acceptanceRate"></div>
            </div>

          </div>
        </div>

        <!-- Upfront Disbursed -->
        <div
          class="bg-white dark:bg-slate-800 p-[18px] rounded-xl border border-slate-100 shadow-sm relative overflow-hidden flex flex-col justify-between">
          <div class="flex justify-between items-start mb-2">
            <h4 class="text-[10.5px] font-[700] tracking-[0.7px] text-slate-500 uppercase">Upfront Disbursed</h4>
            <span
              class="text-[9.5px] font-[700] bg-slate-100 text-slate-600 px-2 py-1 rounded-md uppercase tracking-wider">Advances</span>
          </div>
          <div
            class="font-['Lato',sans-serif] text-[26px] font-normal leading-[1] tracking-[-1px] text-slate-900 dark:text-white mb-2">
            {{ upfrontDisbursedData().totalDisbursedFormatted }}
          </div>
          <div class="text-[11.5px] leading-[1.45] text-slate-500 mb-3">
            {{ upfrontDisbursedData().advancesCount | number }} advances &middot; ${{ upfrontDisbursedData().avgTicket
            | number }} avg ticket &middot; paid out now vs EMIs
          </div>

        </div>
      </div>

      <!-- Right side Donut -->
      <div
        class="md:col-span-6 bg-white dark:bg-slate-800 p-6 rounded-xl border border-slate-100 shadow-sm flex flex-col items-center">
        <div class="w-full mb-6">
          <h4 class="text-[14px] font-[600] text-[#0e1b2e] dark:text-white">Eligibility Outcomes</h4>
          <div class="text-[12px] text-slate-500 mt-1">Accepted &middot; Declined &middot; Deferred (must wait 3/6/9
            mo) &middot; Not eligible</div>
        </div>

        <div class="relative w-full flex items-center my-auto px-4">
          <div class="relative w-[280px] h-[280px] shrink-0">
            <app-donut-chart [data]="timeToContractDonut()" [width]="280" [height]="280" [innerRadiusRatio]="0.75"
              [outerRadiusRatio]="1.0" [radiusScale]="1.0" [showLegend]="false" [showValue]="false"
              [showPolylines]="false" [expandOnHover]="false">
            </app-donut-chart>

            <div class="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
              <span class="text-3xl font-[800] text-slate-900 dark:text-white">{{ timeToContractTotal() | number
                }}</span>
              <span class="text-[11px] font-bold text-slate-500 tracking-wide mt-1 uppercase">TOTAL APPLICANTS</span>
            </div>
          </div>

          <div class="grid grid-cols-2 gap-x-12 gap-y-8 ml-16 w-full">
            @for (item of timeToContractDonut(); track item.label) {
            <div class="flex flex-col">
              <div class="flex items-center gap-2">
                <div class="w-2.5 h-2.5 rounded-sm" [style.backgroundColor]="item.color"></div>
                <span class="text-[13px] font-[500] text-slate-900 dark:text-slate-200 flex items-center">
                  {{ item.label }}
                  @if (item.label === 'Deferred') {
                  <span
                    class="ml-2 px-2 py-0.5 bg-slate-100 dark:bg-slate-700 text-[11px] rounded-full text-slate-600 dark:text-slate-400 font-[600]">3/6/9mo</span>
                  }
                </span>
              </div>
              <div
                class="font-['Lato',sans-serif] text-[26px] font-normal leading-[1] tracking-[-1px] text-slate-900 dark:text-white mt-1 mb-1 pl-[18px]">
                {{ item.value | number
                }}</div>
              <div class="text-[13px] text-slate-600 dark:text-slate-400 pl-[18px] mt-0.5">{{ item?.percentage }}%</div>
            </div>
            }
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Supporter funding -->
  <section class="mb-10">
    <h3
      class="font-['Lato',sans-serif] text-[20px] font-bold tracking-[-0.4px] text-slate-900 dark:text-white normal-case mb-5">
      Supporter Funding
    </h3>

    <!-- Top two cards -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-6 items-stretch relative mb-6">
      @if(isLoading()){ <app-individual-toaster></app-individual-toaster> }

      <!-- CAPITAL FUNDED -->
      <div
        class="bg-white dark:bg-slate-800 p-6 rounded-xl border border-purple-200 dark:border-purple-800 shadow-sm relative overflow-hidden flex flex-col justify-between">
        <div class="flex justify-between items-start mb-2 pl-2">
          <h4 class="text-[11px] font-[700] tracking-[0.7px] text-slate-500 uppercase">CAPITAL FUNDED</h4>
          <span
            class="text-[9.5px] font-[700] bg-purple-50 text-purple-600 px-2 py-1 rounded-md uppercase tracking-wider">INFLOW</span>
        </div>
        <div
          class="font-['Lato',sans-serif] text-[26px] font-normal leading-[1] tracking-[-1px] text-slate-900 dark:text-white mb-2 pl-2">
          ${{ formatToShort(supporterCapitalData().capitalFunded) }}
        </div>
        <div class="text-[12px] leading-[1.45] text-slate-500 mb-6 pl-2">
          {{ supporterCapitalData().subtitle }}
        </div>

        <div class="mt-auto pl-2 pr-1">

        </div>
      </div>

      <!-- REPAID TO SUPPORTERS -->
      <div
        class="bg-white dark:bg-slate-800 p-6 rounded-xl border border-slate-100 dark:border-slate-700 shadow-sm relative overflow-hidden flex flex-col justify-between">
        <div class="flex justify-between items-start mb-2">
          <h4 class="text-[11px] font-[700] tracking-[0.7px] text-slate-500 uppercase">REPAID TO SUPPORTERS</h4>
          <span
            class="text-[9.5px] font-[700] bg-orange-50 text-orange-600 px-2 py-1 rounded-md uppercase tracking-wider">RETURNS</span>
        </div>
        <div
          class="font-['Lato',sans-serif] text-[26px] font-normal leading-[1] tracking-[-1px] text-slate-900 dark:text-white mb-2">
          ${{ formatToShort(supporterRepaymentData().repaid) }}
        </div>
        <div class="text-[12px] leading-[1.45] text-slate-500 mb-6">
          {{ supporterRepaymentData().subtitle }}
        </div>

      </div>

    </div>

    <!-- Supporter capital lifecycle chart -->
    <div
      class="bg-white dark:bg-slate-800 p-6 rounded-xl border border-slate-100 dark:border-slate-700 shadow-sm relative w-full">
      <div class="mb-6">
        <h4 class="text-[15px] font-[700] text-slate-900 dark:text-white">Supporter Capital Lifecycle</h4>
        <div class="text-[13px] text-slate-500 mt-1">Funded &rarr; disbursed to businesses, with the balance still
          outstanding</div>
      </div>
      <div class="w-full relative">
        <app-horizontal-bar-chart [data]="supporterFlowChartData()" [showXAxisGrid]="false" [showXAxisLabel]="false"
          [showYAxisLabel]="true" [showYAxisLine]="false" [colorYAxisLabels]="false"
          yAxisLabelColor="rgb(100, 116, 139)" [barHeight]="35" [barThickness]="35" [marginTop]="20" [marginBottom]="40"
          [leftMargin]="100" [maxBarWidth]="35" scaleType="linear" valueType="currencyShort" [showBarsValue]="true"
          [showTooltipTotal]="false" [minHeight]="150" [yAxisTickPadding]="15" [roundedCorners]="true"
          [cornerRadius]="8"></app-horizontal-bar-chart>
      </div>
    </div>
  </section>